import dayjs from "dayjs";

export const formatDateAndTime = (date, time, textInvalid = "Fecha inválida") => {
  if (!date) return textInvalid;
  const fecha = dayjs(date).format("DD/MMM/YYYY");
  if (fecha === "Invalid Date") return textInvalid;
  const hora = time ? `- ${time}` : "";
  return `${fecha.toLocaleUpperCase()} ${hora.toLocaleLowerCase()}`;
}

export const transFormDateAndHourToDate = (date, time) => {
  if (!date) return null;
  
  try {
    // Parsear la fecha usando dayjs
    const parsedDate = dayjs(date);
    
    if (!parsedDate.isValid()) return null; // Si la fecha no es valida, retornar null
    
    // Si no hay hora, establecer en 00:00 para indicar que no se definió
    if (!time) {
      return parsedDate.hour(0).minute(0).toDate();
    }
    
    const [hours, minutes] = time.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      // Si la hora no es valida, establecer en 00:00 para indicar que no se definió
      return parsedDate.hour(0).minute(0).toDate();
    }
    
    const dateWithTime = parsedDate.hour(hours).minute(minutes); // Combinar fecha y hora
    
    return dateWithTime.toDate(); // Retornar el objeto Date con la fecha y hora
  } catch (error) {
    return null;
  }
}

export const transformDateAndHourToString = (date) => {
  if (!date) return [null, null];
  
  try {
    const parsedDate = dayjs(date);
    
    if (!parsedDate.isValid()) return [null, null];
    
    const fecha = parsedDate.format("DD/MMM/YYYY");
    const hora = parsedDate.format("hh:mm A");
    
    // Si la hora es 12:00 AM, retornar null en la hora
    const horaFinal = hora === "12:00 AM" ? null : hora;
    
    return [fecha, horaFinal];
  } catch (error) {
    return [null, null];
  }
}

export const getHourFromDate = (date) => {
  if (!date) return null;
  return dayjs(date).format("HH:mm");
}